<template>
  <div class="crcl">
    <h2 class="title">Creatinine Clearance Calculator (C-G Equation)</h2>
    <ul id="input">
      <li>
        <input type="radio" v-model="sex" value="male"> male
        <input type="radio" v-model="sex" value="female"> female
      </li>

      <li>
        TBW
        <input class="input" type="integer" v-model="tbw" size="3px"> kg
      </li>

      <li>
        Height
        <input class="input" type="integer" v-model="ht" size="3px">
        cm [BMI {{bmicalc()}}]
      </li>

      <li>
        Age
        <input class="input" type="integer" v-model="age" size="3px">
        years
      </li>

      <li>
        SCr
        <input class="input" type="integer" v-model="scr" size="4px">
        mg/dl
      </li>
      
      
    </ul>

        <div id="dose">
        ➡️ {{crclcalcoriginal.toFixed(0)}} ml/min 
        <br>
        ➡️ {{crclcalc.toFixed(0)}} ml/min (<a href="https://www.mdcalc.com/creatinine-clearance-cockcroft-gault-equation#evidence">modified Cockcroft-Gault</a>)
        </div>
    
  </div>
</template>

<script>
export default {
  name: "crcl",

  data() {
    return {
      tbw: 60,
      ht: 150,
      age: 30,
      scr: 0.9,
      sex: "male"
      
    };
  },
  methods: {
   
    abwcalc() {
      return this.ibwcalc() + 0.4 * (this.tbw - this.ibwcalc());
    },
    bmicalc() {
      return Math.round(this.tbw / Math.pow(this.ht / 100, 2));
    },
    wtforcrclcalc() {
      if (this.bmicalc() >= 25) {
        return this.abwcalc();
      } else if (this.bmicalc() > 18.5) {
        return this.ibwcalc();
      } else {
        return this.tbw;
      }
    },
    ibwcalc() {
      if (this.sex === "male") {
        return 50 + 2.3 * (this.ht / 2.54 - 60);
      } else {
        return 45.5 + 2.3 * (this.ht / 2.54 - 60);
      }
    }
  },
  computed: {
    
    crclcalc() {
      if (this.sex === "male") {
        return ((140 - this.age) * this.wtforcrclcalc()) / (72 * this.scr);
      } else {
        return (
          ((140 - this.age) * (this.wtforcrclcalc() * 0.85)) / (72 * this.scr)
        );
      }
    },
    crcl() {
      if (this.crcluse === "modified") {
        return this.crclcalc.toFixed(0);
      } else if (this.crcluse === "original") {
        return this.crclcalcoriginal.toFixed(0);
      } else {
        return this.crclman;
      }
    },
    crclcalcoriginal() {
      if (this.sex === "male") {
        return ((140 - this.age) * this.tbw) / (72 * this.scr);
      } else {
        return ((140 - this.age) * (this.tbw * 0.85)) / (72 * this.scr);
      }
    },
    
  }
};
</script>

<style scope >
div {
  margin-top: 10px;
}
ul#input li {
  display: list-item;
  list-style-type: none;
}
span#dose {
  font-size: 25px;
  color: #4f9bb2;
  background-color: #fccbcb;
}



.input {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #364f6b;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px thin #4f9bb2;
}
</style>